import axios from "axios";
import React, { useEffect, useState } from "react";

// import "./AdminFanGroup.css";
import AllModuleData from "../../../Components/Reuseable/AllModuleData";
import LoaderPost from "../../../Components/Reuseable/LoaderPost";
import AdminFanGroupNav from "./Content/AdminFanGroupNav";

const AdminFanGroup = () => {
  const [event_data, setFanLiveGroup] = useState([]);
  const [fanPendingCount, setFanPendingCount] = useState([]);
  const [buffer, setBuffer] = useState(true);

  useEffect(() => {
    axios.get(`/api/admin/fan/group/adminlist/status`).then((res) => {
      setBuffer(false);
      if (res.status === 200) {
        setFanPendingCount(res.data.fanPendingCount);
        setFanLiveGroup(res.data.fanLiveGroup);
      }
    });
  }, []);
  return (
    <>
      <AdminFanGroupNav />

      <div className="mt-3 p-2">
        <div className="head-line mb-2">
          <div className="text-light d-flex justify-content-center p-2">
            <div className="faTrophy">
              <i className="fas fa-trophy"></i>
            </div>
            <h4 className="mx-3 text-white p-2">
              <span className="livechat-card-small">Fan Group</span>
            </h4>
          </div>
        </div>
        {buffer ? (
          <LoaderPost />
        ) : (
          <AllModuleData
            data={event_data}
            urlLink={`/superstar-admin/fangroup/view`}
            fan={"true"}
          />
        )}
      </div>
    </>
  );
};

export default AdminFanGroup;
